import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import config from '../../config';
import pages from '../../constants/pages';
import '../../asset/js/paper-dashboard';
import './index.css'
import { withNamespaces } from 'react-i18next';
import logoutSVG from '../../asset/img/logout.svg';
import gallerySVG from '../../asset/img/gallery.svg';
import i18n from "i18next";
import {Button} from "react-bootstrap";
import OAuth2 from "../../constants/OAuth2";


const SideBarItem = ({ page, activePath }) => {
  if (activePath.startsWith(page.path)) {
    return (
        <li className="active">
          <a>
            <i className={page.icon} />
            <p>
              {i18n.t(page.title)}
            </p>
          </a>
        </li>
    );
  }


  return (
      <li>
        <Link to={activePath.startsWith(page.path) ? '' : page.path}>
          <i className={page.icon} />
          <p>
            {i18n.t(page.title)}
          </p>
        </Link>
      </li>
  );
};

const handleButtonClick = () => {
  window.location.href = OAuth2.galleryRedirect;
};
const SideBar = props => (
    <div
        className="sidebar"
        data-background-color="white"
        data-active-color="danger"
    >
      <div className="sidebar-wrapper">
        <div className="logo">
          <Link to="/travel-expense-request" className="simple-text">
            {' '}
            {i18n.t(config.app.title)}
          </Link>
        </div>
        <ul className="nav">
          {pages.filter(page => !page.hidden)
              .map(page => (
                  <SideBarItem
                      key={page.path}
                      activePath={props.activePath}
                      page={page}
                  />
              ))}

          <li className="gallery-button">
            <Button className="gallery-ui" onClick={handleButtonClick}>
              <div className="gallery-container">
                <img src={gallerySVG} className="svg-file"/>
                <p className="gallery-text">{i18n.t('allApplication')}</p>
              </div>
            </Button>
          </li>
          <li className="active-pro hidden-lg-up">
            <Link id="logout" to="/logout">
              <i><img src={logoutSVG}/></i>
              <p>
                {i18n.t('logout')}
              </p>
            </Link>
          </li>


        </ul>

      </div>

    </div>
);

const mapStateToProps = state => ({
  activePath: state.routing.location.pathname,
});

export default withNamespaces()(connect(mapStateToProps)(SideBar));



// WEBPACK FOOTER //
// ./src/components/sidebar/index.js